import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageContent } from '@/components/page-content'
import { PageHeader } from '@/components/page-header'
import { PageHeaderSkeleton } from '@/components/skeleton/page-header-skeleton'
import { Skeleton } from '@/components/ui/skeleton'
import { CreateOrUpdateForm } from '@/features/jobs/edit/index/create-or-update-form'
import { jobsInfoQuery } from '@/queries/use-jobs-queries'

export const Route = createFileRoute('/_authenticated/jobs_/$jobId_/edit/')({
  component: JobEdit,
  loader: ({ context: { queryClient }, params: { jobId } }) => queryClient.ensureQueryData(jobsInfoQuery(jobId)),
  pendingComponent: () => (
    <>
      <PageHeaderSkeleton title="Job informations" />
      <PageContent>
        <Skeleton className="h-96 w-full" />
      </PageContent>
    </>
  ),
})

function JobEdit() {
  const { jobId } = Route.useParams()
  const { data: jobInformations } = useSuspenseQuery(jobsInfoQuery(jobId))

  return (
    <>
      <PageHeader title="Job informations" />
      <PageContent>
        <CreateOrUpdateForm jobInformations={jobInformations} />
      </PageContent>
    </>
  )
}
